// extracted by mini-css-extract-plugin
export default {"lightOverlay":"dark-overlay_lightOverlay__jiVLM","darkOverlay":"dark-overlay_darkOverlay__Q-b-5"};